var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div_temporarily_no_data"},[_c('svg',{staticClass:"img",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"href":("#" + _vm.imgSrc)}})]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.titleWord)}})])}
var staticRenderFns = []

export { render, staticRenderFns }